export const getDeviceTypes = state => {
    return state.deviceTypes.data;
};
